import React from "react";
import { useEffect } from "react";
import SEO from '../../components/SEO/SEO';
import { seoConfig } from '../../config/seoConfig';

const ContactUs = () => {
  //   useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);
  return (
    <>
      <SEO 
        title={seoConfig.contact.title}
        description={seoConfig.contact.description}
        keywords={seoConfig.contact.keywords}
        ogImage={seoConfig.contact.ogImage}
        canonical={seoConfig.contact.canonical}
      />
      <div
      data-layer="Contact Us-Desktop"
      className="ContactUsDesktop w-full min-h-screen bg-Color-White flex flex-col justify-center items-center overflow-hidden"
    >
      <div
        data-layer="Image Container"
        className="ImageContainer w-full max-w-[2000px] px-4 sm:px-6 md:px-8 lg:px-16 py-4 sm:py-6 md:py-8 lg:py-10 flex flex-col lg:flex-row justify-center items-start gap-4 sm:gap-6 lg:gap-10"
      >
        <div
          data-layer="Contact Info Header"
          className="lg:hidden  ContactInfoHeader self-stretch flex flex-col justify-start items-start gap-3 sm:gap-4 lg:gap-6 xl:gap-8"
        >
          <div
            data-layer="Celebrating a Legacy"
            className="CelebratingALegacy self-stretch justify-start mb-4 sm:mb-6"
          >
            <span className="text-Color-Black text-2xl sm:text-3xl md:text-5xl lg:text-5xl xl:text-6xl font-normal font-['Montserrat']">
              Contact{" "}
            </span>
            <span className="text-Color-Brand text-2xl sm:text-3xl md:text-5xl lg:text-5xl xl:text-6xl font-semibold font-['Montserrat'] underline">
              Us
            </span>
          </div>
          <div
            data-layer="Contact Info Description"
            className="ContactInfoDescription w-full lg:max-w-[632px] justify-start text-Color-Black text-sm sm:text-base md:text-lg lg:text-lg font-medium font-['Montserrat'] tracking-tight leading-relaxed"
          >
            We'd love to hear from you! Whether you have a question about our
            programs, wish to connect with our faculty, or explore partnership
            opportunities, please don't hesitate to reach out.
          </div>
        </div>
        {/* SVG Section*/}
        <div
          data-layer="Image"
          className=" pt-16 lg:pt-0 pb-16 lg:pb-0 Image w-full flex flex-1 flex-col justify-start items-center lg:items-end gap-4 sm:gap-6 lg:gap-24"
        >
          <div
            data-layer="SVG"
            className="Svg w-full  lg:h-[500px] xl:h-[843.16px] lg:max-w-[600px] xl:max-w-[905.16px] max-h-[1200px] relative overflow-hidden"
          >
            <img
              src="/assets/Frame.svg"
              alt="Background Frame"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Content Section - Full width on mobile */}
        <div
          data-layer="Frame 1"
          className="Frame1 w-full lg:flex-1 flex justify-center items-start gap-2"
        >
          <div
            data-layer="Contact Info Container"
            className="ContactInfoContainer w-full max-w-[800px] pl-0 lg:pl-6 xl:pl-10 flex flex-col justify-start items-start gap-4 sm:gap-6 lg:gap-8 xl:gap-10"
          >
            {/* Header */}
            <div
              data-layer="Contact Info Header"
              className="hidden lg:block ContactInfoHeader self-stretch flex flex-col justify-start items-start gap-3 sm:gap-4 lg:gap-6 xl:gap-8"
            >
              <div
                data-layer="Celebrating a Legacy"
                className="CelebratingALegacy self-stretch justify-start mb-4 sm:mb-6 lg:mb-8"
              >
                <span className="text-Color-Black text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-normal font-['Montserrat']">
                  Contact{" "}
                </span>
                <span className="text-Color-Brand text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-semibold font-['Montserrat'] underline">
                  Us
                </span>
              </div>
              <div
                data-layer="Contact Info Description"
                className="ContactInfoDescription w-full max-w-[632px] justify-start text-Color-Black text-sm sm:text-base lg:text-lg font-medium font-['Montserrat'] tracking-tight leading-relaxed"
              >
                We'd love to hear from you! Whether you have a question about
                our programs, wish to connect with our faculty, or explore
                partnership opportunities, please don't hesitate to reach out.
              </div>
            </div>

            {/* Contact Details */}
            <div
              data-layer="Contact Details Container"
              className="ContactDetailsContainer self-stretch flex flex-col justify-start items-start gap-4 sm:gap-6 md:gap-8"
            >
              {/* Location */}
              <div
                data-layer="Location Container"
                className="LocationContainer w-full self-stretch py-2 flex flex-col md:flex-row md:justify-between lg:justify-start items-start gap-3 sm:gap-4 md:gap-6 xl:gap-8"
              >
                <div
                  data-layer="Location Label"
                  className="LocationLabel w-full md:flex-1 justify-start text-Color-Brand text-lg sm:text-xl md:text-2xl font-bold font-['Montserrat'] uppercase tracking-tight"
                >
                  Our Location:
                </div>
                <div
                  data-layer="Location Address"
                  className="LocationAddress w-full md:flex-1 justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] tracking-tight leading-relaxed"
                >
                  Faculty of Engineering,
                  <br />
                  University of Ruhuna,
                  <br />
                  Hapugala,
                  <br />
                  Galle, 80000
                  <br />
                  Sri Lanka
                </div>
              </div>

              {/* Inquiries */}
              <div
                data-layer="Inquiries Container"
                className="InquiriesContainer self-stretch py-2 flex flex-col md:flex-row justify-start items-start gap-3 sm:gap-4 md:gap-6 xl:gap-8"
              >
                <div
                  data-layer="Inquiries Label"
                  className="InquiriesLabel w-full md:flex-1 justify-start text-Color-Brand text-lg sm:text-xl md:text-2xl font-bold font-['Montserrat'] uppercase tracking-tight"
                >
                  General Inquiries:
                </div>
                <div
                  data-layer="Inquiries Details"
                  className="InquiriesDetails w-full md:flex-1 flex flex-col justify-center items-start gap-3 sm:gap-4"
                >
                  {/* Phone Numbers */}
                  <div
                    data-layer="Phone Numbers Container"
                    className="PhoneNumbersContainer self-stretch flex flex-col justify-center items-start gap-1 sm:gap-2"
                  >
                    <div
                      data-layer="Phone Numbers Label"
                      className="PhoneNumbersLabel self-stretch justify-start text-Color-Black text-base sm:text-lg font-bold font-['Montserrat'] uppercase tracking-tight"
                    >
                      Phone numbers:
                    </div>
                    <div
                      data-layer="Phone Numbers List"
                      className="PhoneNumbersList self-stretch justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] tracking-tight leading-relaxed"
                    >
                      +(94) 912245761,
                      <br />
                      +(94) 912245767,
                      <br />
                      +(94) 913924732,
                      <br />
                      +(94) 912245765/66
                    </div>
                  </div>

                  {/* Fax */}
                  <div
                    data-layer="Fax Container"
                    className="FaxContainer self-stretch flex flex-col justify-center items-start gap-1 sm:gap-2"
                  >
                    <div
                      data-layer="Fax Label"
                      className="FaxLabel self-stretch justify-start text-Color-Black text-base sm:text-lg font-bold font-['Montserrat'] uppercase tracking-tight"
                    >
                      Fax:
                    </div>
                    <div
                      data-layer="Fax Number"
                      className="FaxNumber self-stretch justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] tracking-tight"
                    >
                      +94 912245762
                    </div>
                  </div>

                  {/* Email */}
                  <div
                    data-layer="Email Container"
                    className="EmailContainer self-stretch flex flex-col justify-center items-start gap-1 sm:gap-2"
                  >
                    <div
                      data-layer="Email Label"
                      className="EmailLabel self-stretch justify-start text-Color-Black text-base sm:text-lg font-bold font-['Montserrat'] uppercase tracking-tight"
                    >
                      E-mail:
                    </div>
                    <div
                      data-layer="Email Address"
                      className="EmailAddress self-stretch justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] tracking-tight break-all"
                    >
                      dean@eng.ruh.ac.lk
                      <br />
                      ar@eng.ruh.ac.lk
                    </div>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div
                data-layer="Social Media Container"
                className="SocialMediaContainer self-stretch py-2 flex flex-col md:flex-row justify-start items-start gap-3 sm:gap-4 md:gap-6 xl:gap-8"
              >
                <div
                  data-layer="Social Media Label"
                  className="SocialMediaLabel w-full md:flex-1 justify-start text-Color-Brand text-lg sm:text-xl md:text-2xl font-bold font-['Montserrat'] uppercase tracking-tight"
                >
                  Connect with Us Online:
                </div>
                <div
                  data-layer="Social Media Links"
                  className="SocialMediaLinks w-full md:flex-1 flex justify-start items-center gap-2"
                >
                  <div
                    data-layer="Social Media Icons"
                    className="SocialMediaIcons inline-flex flex-col justify-center items-start gap-3 sm:gap-4 overflow-hidden"
                  >
                    <div
                      data-layer="Facebook Link"
                      className="FacebookLink inline-flex justify-start items-center gap-2"
                    >
                      <div
                        data-layer="facebook-circle-fill"
                        className="FacebookCircleFill w-5 h-5 sm:w-6 sm:h-6 relative overflow-hidden flex-shrink-0"
                      >
                        <img
                          src="/icons/facebook-circle-fill.svg"
                          alt="Facebook Icon"
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <a
                        href="https://www.facebook.com/EfacUOR"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="FacebookText justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] underline tracking-tight hover:text-Color-Brand transition-colors"
                      >
                        Facebook
                      </a>
                    </div>
                    <div
                      data-layer="LinkedIn Link"
                      className="LinkedinLink inline-flex justify-start items-center gap-2"
                    >
                      <div
                        data-layer="linkedin-box-fill"
                        className="LinkedinBoxFill w-5 h-5 sm:w-6 sm:h-6 relative overflow-hidden flex-shrink-0"
                      >
                        <img
                          src="/icons/linkedin-box-fill.svg"
                          alt="LinkedIn Icon"
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <a
                        href="https://www.linkedin.com/company/faculty-of-engineering-university-of-ruhuna/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="FacebookText justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] underline tracking-tight hover:text-Color-Brand transition-colors"
                      >
                        LinkedIn
                      </a>
                    </div>
                    <div
                      data-layer="YouTube Link"
                      className="YoutubeLink inline-flex justify-start items-center gap-2"
                    >
                      <div
                        data-layer="youtube-fill"
                        className="YoutubeFill w-5 h-5 sm:w-6 sm:h-6 relative overflow-hidden flex-shrink-0"
                      >
                        <img
                          src="/icons/youtube-fill.svg"
                          alt="YouTube Icon"
                          className="w-full h-full object-contain"
                        />
                      </div>
                      <a
                        href="https://www.youtube.com/@refmedia"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="FacebookText justify-start text-Color-Black text-sm sm:text-base md:text-lg font-medium font-['Montserrat'] underline tracking-tight hover:text-Color-Brand transition-colors"
                      >
                        YouTube
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div
        data-layer="Social Media Container"
        className="SocialMediaContainer w-full px-4 sm:px-6 md:px-8 lg:px-16 xl:px-24 py-4 sm:py-6 lg:py-8 xl:py-10 flex flex-col justify-start items-start gap-4 sm:gap-6 lg:gap-8"
      >
        <div
          data-layer="Find Us on Map"
          className="FindUsOnMap self-stretch justify-start text-Color-Brand text-lg sm:text-xl lg:text-2xl font-bold font-['Montserrat'] uppercase tracking-tight"
        >
          Find Us on the Map:
        </div>
        <div
          data-layer="Map Container"
          className="MapContainer self-stretch h-48 sm:h-56 md:h-64 lg:h-80 xl:h-96"
        >
          <div
            data-layer="Map Embed"
            className="MapEmbed w-full h-full justify-start text-Color-Black text-sm sm:text-base lg:text-lg font-medium font-['Montserrat'] tracking-tight"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3967.3772326051703!2d80.192519!3d6.079765!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae1714b88f66a7b%3A0x8a7feea89839a01a!2sFaculty%20of%20Engineering%20-%20University%20of%20Ruhuna!5e0!3m2!1sen!2slk!4v1751096607010!5m2!1sen!2slk"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Faculty of Engineering - University of Ruhuna Location"
            />
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default ContactUs;
